var _circle, _path, _path2, _circle2, _circle3, _circle4, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9861,
    cy: 32.4471,
    r: 32.4471,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0272 24.792L68.4609 33.3806L65.2868 67.1751L28.8784 58.0263L38.0272 24.792Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2743 33.194L36.3469 24.9788C34.791 27.2193 30.783 33.0073 27.1981 38.2351C23.6133 43.463 17.3648 49.8734 14.6886 52.4251L52.0305 63.4409C52.7151 63.0675 55.6153 60.3416 61.7394 52.4251C67.8635 44.5086 68.6477 36.3058 68.2743 33.194Z",
    fill: "#F3F3F3",
    stroke: "#CCCCCC",
    strokeWidth: 0.818293
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1475,
    cy: 33.7542,
    r: 1.49368,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6665,
    cy: 41.596,
    r: 1.49368,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1854,
    cy: 48.6909,
    r: 1.49368,
    fill: "#C4C4C4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.4827,
    y: 42.885,
    width: 17.9241,
    height: 0.746839,
    rx: 0.373419,
    transform: "rotate(15.5 38.4827 42.885)",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5735,
    y: 50.4524,
    width: 16.2239,
    height: 0.746839,
    rx: 0.373419,
    transform: "rotate(15.5 34.5735 50.4524)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4033,
    y: 34.8914,
    width: 17.9241,
    height: 0.746839,
    rx: 0.373419,
    transform: "rotate(14.5 43.4033 34.8914)",
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecord);
export default __webpack_public_path__ + "static/media/no_record.4be95b5ed4f8a07757b1d52778f9ac8b.svg";
export { ForwardRef as ReactComponent };